import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../common/models';
import {
  AutomotiveAftermarketProfileItemBriefState,
  AutomotiveAftermarketProfileItemBriefStateModel,
} from './automotive-aftermarket-profile-item-brief.state';
import { AutomotiveAftermarketProfileDetails, AutomotiveAftermarketProfileModel } from '../models';
import { MatDialogRef } from '@angular/material/dialog';
import {
  AutomotiveAftermarketProfileItemBriefClone,
  AutomotiveAftermarketProfileItemBriefDelete,
  AutomotiveAftermarketProfileItemBriefInitialState,
  AutomotiveAftermarketProfileItemBriefLoad,
  AutomotiveAftermarketProfileItemBriefSave,
} from './automotive-aftermarket-profile-item-brief.actions';
import { ConfirmationDialogAfterClosedModel } from '../../../../../ui-kit';

@Injectable({ providedIn: 'root' })
export class AutomotiveAftermarketProfileItemBriefFacade implements LoadDataFacade, SetInitialStateFacade {
  profileId$: Observable<number> = this.store.select(AutomotiveAftermarketProfileItemBriefState.getProfileId);

  profile$: Observable<AutomotiveAftermarketProfileItemBriefStateModel> = this.store.select(
    AutomotiveAftermarketProfileItemBriefState.getState,
  );

  loaded$: Observable<boolean> = this.store.select(AutomotiveAftermarketProfileItemBriefState.getLoaded);

  constructor(private store: Store) {}

  loadAll(automotiveAftermarketProfileId: number): void {
    this.store.dispatch(new AutomotiveAftermarketProfileItemBriefLoad(automotiveAftermarketProfileId));
  }

  saveProfile(profile: Partial<AutomotiveAftermarketProfileDetails>): void {
    this.store.dispatch(new AutomotiveAftermarketProfileItemBriefSave(profile));
  }

  cloneProfile(data: Partial<AutomotiveAftermarketProfileModel>): void {
    this.store.dispatch(new AutomotiveAftermarketProfileItemBriefClone(data));
  }

  deleteProfile(profileId: number, dialog: MatDialogRef<ConfirmationDialogAfterClosedModel>): void {
    this.store.dispatch(new AutomotiveAftermarketProfileItemBriefDelete({ dialog, profileId }));
  }

  setInitialState(): void {
    this.store.dispatch(new AutomotiveAftermarketProfileItemBriefInitialState());
  }
}
